import styled from 'styled-components'
import { FONT_WEIGHT } from 'Theme'

export const Strong = styled('strong')`
  font-weight: ${FONT_WEIGHT.SEMI_BOLD};
`
